/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DispositionSagasUpdateAutoDispoStatusQueryVariables = {
    stationId: string;
};
export type DispositionSagasUpdateAutoDispoStatusQueryResponse = {
    readonly autoDispo: {
        readonly isDeactivated: boolean | null;
    } | null;
};
export type DispositionSagasUpdateAutoDispoStatusQuery = {
    readonly response: DispositionSagasUpdateAutoDispoStatusQueryResponse;
    readonly variables: DispositionSagasUpdateAutoDispoStatusQueryVariables;
};



/*
query DispositionSagasUpdateAutoDispoStatusQuery(
  $stationId: String!
) {
  autoDispo(stationId: $stationId) {
    isDeactivated
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "stationId",
        "variableName": "stationId"
      }
    ],
    "concreteType": "AutoDispo",
    "kind": "LinkedField",
    "name": "autoDispo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeactivated",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DispositionSagasUpdateAutoDispoStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DispositionSagasUpdateAutoDispoStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9cb4d15a5805cfa8f4354fbdc4f60718",
    "id": null,
    "metadata": {},
    "name": "DispositionSagasUpdateAutoDispoStatusQuery",
    "operationKind": "query",
    "text": "query DispositionSagasUpdateAutoDispoStatusQuery(\n  $stationId: String!\n) {\n  autoDispo(stationId: $stationId) {\n    isDeactivated\n  }\n}\n"
  }
};
})();
(node as any).hash = 'da9b0791afa9bc02c5ca15b218696a40';
export default node;
